import {
  CASPackageName,
  CASPackageNumber,
} from '../../filenameTemplateItems/instances/cas'
import {
  constructionSubmittals,
  projects,
} from '../../filenameTemplateItems/instances/groups'
import { SharePointPacketReportItem } from '../classes/SharePointPacketReportItem'

export const ConstructionAdminSubmittal = new SharePointPacketReportItem({
  id: '4a562b85-a6ec-4b3d-9629-b4bf503da940',
  classType: 'ConstructionAdminSubmittal',
  classTypeName: 'Construction & Admin Submittal',
  endpoint: 'construction-admin-submittals',
  compatibleTemplateItems: [...projects, ...constructionSubmittals],
  afterClientProjectNumber: [
    { type: 'custom', text: '_SUBMITTAL_' },
    { type: 'templateItem', templateItemId: CASPackageNumber.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: CASPackageName.id },
  ],
  label: 'packageNumber',
  name: 'Construction & Admin Submittal',
  queryParameter: 'construction-admin-submittal',
  sampleFilename: 'construction-admin-submittal',
  key: 'id',
})
